export default function setupSearch() {
  const toggle = document.getElementById('searchToggle')
  const bar = document.getElementById('searchBar')
  const input = document.getElementById('searchInput')
  const close = document.getElementById('searchClose')

  if (!toggle || !bar) return

  toggle.addEventListener('click', () => {
    const isOpen = bar.classList.toggle('is-open')
    if (isOpen && input) {
      input.focus()
    }
  })

  if (close) {
    close.addEventListener('click', () => {
      bar.classList.remove('is-open')
    })
  }

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && bar.classList.contains('is-open')) {
      bar.classList.remove('is-open')
    }
  })
}
